import { getReadableColor } from "../../helpers";
var boxes = {
  header: {
    backgroundColor: "background",
    color: function color(theme) {
      return getReadableColor(theme, "background");
    },
    padding: 2
  },
  headerSecondary: {
    backgroundColor: "background",
    color: function color(theme) {
      return getReadableColor(theme, "background");
    }
  },
  hero: {
    backgroundColor: "highlight",
    color: function color(theme) {
      return getReadableColor(theme, "highlight");
    }
  },
  section: {
    borderColor: "primary",
    borderWidth: "medium",
    borderStyle: "solid",
    padding: 4
  },
  callOut: {
    backgroundColor: "primary",
    color: function color(theme) {
      return getReadableColor(theme, "primary");
    },
    padding: 4
  },
  footer: {
    backgroundColor: "background",
    color: function color(theme) {
      return getReadableColor(theme, "background");
    },
    paddingTop: 5,
    paddingBottom: 5
  },
  credits: {
    backgroundColor: "background",
    color: function color(theme) {
      return getReadableColor(theme, "background");
    },
    paddingTop: 3,
    paddingBottom: 3
  }
};
export default boxes;